<!-- <h1 mat-dialog-title>Time Evaluation</h1> -->

<mat-dialog-content class="!mt-8 !flex flex-col">
  <div class="mb-1 flex w-full flex-row justify-end">
    <span class="text-sm uppercase">week ending {{ weDate }}</span>
  </div>
  <div class="flex h-14 w-full flex-row items-center justify-between bg-[#ececec] px-2">
    <div class="text-xl font-semibold">
      <span>{{ employee.display }}</span>
    </div>
    <div class="flex flex-wrap text-end text-sm">
      <span class="w-full">{{ otType }}</span>
      <span class="w-full">{{ workScheduleRule }}</span>
    </div>
  </div>
  <div
    class="flex flex-col items-center gap-16 xl:flex-row"
    [class.justify-center]="!elementsDisplay.multiWindow"
    [class.justify-between]="elementsDisplay.multiWindow"
  >
    @if (!elementsDisplay.hidePayrollAutomationWindow) {
      <div class="flex flex-col items-center justify-start">
        <div class="flex h-12 w-full items-center justify-center">
          @if (!hasAutomationOverride) {
            <span class="text-[#006a9a]">Current Selection</span>
          }
        </div>
        <div
          class="flex cursor-pointer flex-col items-center justify-start gap-4 rounded-b-md bg-white transition ease-in"
          matTooltip="Accept Payroll Automation"
          [ngClass]="!hasAutomationOverride ? 'drop-shadow-lg' : 'opacity-40 hover:drop-shadow-lg'"
          (click)="toggleAutomationOverride(false)"
        >
          <div class="flex h-14 w-full items-center justify-start rounded-t-md bg-[#ececec] pl-4 text-xl font-semibold">
            Payroll Automation
          </div>
          <table-like-layout
            class="min-w-[465px] text-sm font-semibold"
            appearance="timeEval"
            [config]="config"
            [values]="timeEval"
          />
          <div class="flex w-full justify-between pb-4 pl-4">
            <span class="text-sm font-semibold">Total Paid Hours </span>
            <span class="w-[46px] text-center text-sm font-semibold">{{ timeEvalTotalPaid }} </span>
          </div>
        </div>
      </div>
    }
    @if (!elementsDisplay.hideTimesheetWindow) {
      <div class="flex flex-col items-center justify-start">
        <div class="flex h-12 w-full items-center justify-center">
          @if (hasAutomationOverride) {
            <span class="text-[#006a9a]">Current Selection</span>
          }
        </div>
        <div
          class="flex cursor-pointer flex-col items-center justify-start gap-4 rounded-b-md bg-white transition ease-in"
          matTooltip="Override Payroll Automation"
          [ngClass]="hasAutomationOverride ? 'drop-shadow-lg' : 'opacity-40 hover:drop-shadow-lg'"
          (click)="toggleAutomationOverride(true)"
        >
          <div class="flex h-14 w-full items-center justify-start rounded-t-md bg-[#ececec] pl-4 text-xl font-semibold">
            Timesheet
          </div>
          <table-like-layout
            class="min-w-[465px] text-sm font-semibold"
            appearance="timeEval"
            [config]="config"
            [values]="timesheet"
          />
          <div class="flex w-full justify-between pb-4 pl-4">
            <span class="text-sm font-semibold">Total Paid Hours </span>
            <span class="w-[46px] text-center text-sm font-semibold">{{ timesheetTotalPaid }} </span>
          </div>
        </div>
      </div>
    }
  </div>
  @if (unpaidHours !== '0') {
    <div class="w-full pt-12 text-center text-red-600">{{ unpaidHours }} hours UNPAID not shown</div>
  }
</mat-dialog-content>

@if (!elementsDisplay.hideButton) {
  <mat-dialog-actions>
    <button mat-raised-button (click)="accept()">Accept</button>
  </mat-dialog-actions>
}
